import React from "react";
import Flex from "../../../../structure/Flex";

type CustomSet = (value: number) => void;

interface AmountSelectorProps {
  value: number;
  setValue: React.Dispatch<number> | CustomSet;
  maxValue?: number;
}

const AmountSelector: React.FC<AmountSelectorProps> = ({
  value,
  setValue,
  maxValue,
}) => {
  return (
    <Flex
      className="rounded-lg shadow-sm overflow-hidden flex-shrink-0"
      items="center"
    >
      <button
        className="w-8 h-8 flex whitespace-no-wrap items-center justify-center font-medium bg-orange text-white"
        onClick={(e) => {
          e.stopPropagation();
          setValue(value - 1);
        }}
      >
        -
      </button>
      <input
        type="number"
        className="appearance-none w-8 h-8 text-center flex items-center justify-center text-sm bg-accent tracking-wider"
        value={value}
        onChange={(e) => {
          e.stopPropagation();
          if (!isNaN(+e.target.value)) {
            if (maxValue) {
              if (+e.target.value <= maxValue) {
                setValue(+e.target.value);
              } else {
                setValue(maxValue);
              }
            } else {
              setValue(+e.target.value);
            }
          }
        }}
      />
      <button
        className="w-8 h-8 flex whitespace-no-wrap items-center justify-center font-medium bg-orange text-white disabled:bg-subtitle disabled:cursor-not-allowed"
        disabled={maxValue ? value >= maxValue : false}
        onClick={(e) => {
          e.stopPropagation();
          if (maxValue && value + 1 <= maxValue) {
            setValue(value + 1);
          } else {
            setValue(value + 1);
          }
        }}
      >
        +
      </button>
    </Flex>
  );
};

export default AmountSelector;
